import { Controller } from "react-hook-form";
import PropTypes from "prop-types";
import * as React from "react";
import TextInput from "./TextInput";
import { ErrorMessage } from "@hookform/error-message";
import ErrorMessageContainer from "shared/components/feedback/error/ErrorMessageContainer";
import Validation from "shared/constants/validationMessages";

const TextInputWithValidation = (props) => {
    return (
        <Controller
            name={props.name}
            control={props.control}
            defaultValue={props.defaultValue || ""}
            render={({
                field: { onChange, onBlur, value, name: fieldName },
            }) => (
                <>
                    <TextInput
                        label={props.label}
                        {...props}
                        onChange={(e) => {
                            onChange(e);
                            props.onChange(e);
                        }}
                        value={value}
                        onBlur={onBlur}
                        name={fieldName}
                        className={
                            !props.className &&
                            props.errors[fieldName] &&
                            "error"
                        }
                        defaultValue={props.defaultValue || ""}
                    />
                    <ErrorMessage
                        errors={props.errors}
                        name={fieldName}
                        as={<ErrorMessageContainer />}
                    />
                </>
            )}
            rules={
                !props.rules && {
                    required:
                        props.required && Validation.required + props.name,
                    maxLength: props.maxLength && {
                        value: props.maxLength,
                        message: Validation.maxLength + props.maxLength,
                    },
                }
            }
        />
    );
};

TextInputWithValidation.propTypes = {
    name: PropTypes.string.isRequired,
    control: PropTypes.object.isRequired,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    className: PropTypes.string,
    required: PropTypes.bool,
    maxLength: PropTypes.number,
    rules: PropTypes.object,
};

export default TextInputWithValidation;
